import { ImageComponent } from "@educaplay/core"
import styles from "./ImageCard.module.scss"
import clsx from "clsx"

export function ImageCard({ sourceImage, className}) {
    return <div className={clsx(styles.cardImageContainer, className)} onClick={(e)=>e.stopPropagation()}>
        <ImageComponent source={sourceImage} className={styles.imageOverride}/>
    </div>
}